import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import Typography from '@mui/material/Typography';
import { getTranslation } from '../../../../utils/translations';
import translations from '../../translations';
import useEmotionStyles from '../../../../uikit/hooks/useEmotionStyles';
var t = getTranslation(translations);
var styles = function (theme) { return ({
    root: {
        display: 'flex',
        margin: "".concat(theme.spacing(3), " 0"),
    },
    icon: {
        marginRight: theme.spacing(1),
        marginLeft: -theme.spacing(0.5),
    },
}); };
var ApplicantHead = function (props) {
    var count = props.count, number = props.number;
    var cs = useEmotionStyles(styles);
    if (count === 1) {
        return null;
    }
    return (React.createElement(Typography, { variant: 'h5', className: cs.root },
        React.createElement(PersonIcon, { className: cs.icon }), "".concat(t.applicant),
        " ",
        number));
};
export default ApplicantHead;
